module.exports = __webpack_public_path__ + "components/MapControl/svg/Galeria handlowa.svg?6d6a7d46";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Galeria handlowa.svg
// module id = 1929
// module chunks = 0